import React, { useState, useEffect } from 'react';
import './admin.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTrashAlt, faSave, faEdit } from '@fortawesome/free-solid-svg-icons';
import AddProduct from './product/addProduct';
function Admin() {
  const [orders, setOrders] = useState([]);
  const [userQueries, setUserQueries] = useState([]);
  const [customerFeedbacks, setCustomerFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState('orders');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [estimatedDates, setEstimatedDates] = useState({}); // New state



  const [products, setProducts] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [editProductId, setEditProductId] = useState(null);

  // Toggle form visibility
  const toggleAddForm = () => {
    setShowAddForm((prev) => !prev);
    // Reset editing state on toggle
    setEditProductId(null);
    setEditData({});
  };

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://swarna-herbal-backend.onrender.com/api/admin/login", {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginData),
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('authToken', data.token);
        setIsLoggedIn(true);
        setError(null);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Failed to login');
    }
  };

  const handlePopularChange = async (productId, isChecked) => {
    await fetch(`https://swarna-herbal-backend.onrender.com/api/products/${productId}/popular`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ popular: isChecked }) // true or false
    });
    getProducts(); // refresh list
  };


  const handleNewLaunchChange = async (productId, isChecked) => {
    await fetch(`https://swarna-herbal-backend.onrender.com/api/products/${productId}/newlaunch`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newLaunch: isChecked }) // true or false
    });
    getProducts(); // refresh list
  };



  const getOrders = async () => {
    try {
      const response = await fetch("https://swarna-herbal-backend.onrender.com/api/orders/get-orders");
      const data = await response.json();
      if (response.ok) setOrders(data.orders);
      else alert('Failed to fetch orders');
    } catch {
      alert('Failed to fetch orders');
    } finally {
      setLoading(false);
    }
  };

  const getUserQueries = async () => {
    try {
      const response = await fetch("https://swarna-herbal-backend.onrender.com/api/contact/get-contact-messages");
      const data = await response.json();
      if (response.ok) setUserQueries(data);
      else alert('Failed to fetch user queries');
    } catch {
      alert('Failed to fetch user queries');
    } finally {
      setLoading(false);
    }
  };

  const getCustomerFeedbacks = async () => {
    try {
      const response = await fetch("https://swarna-herbal-backend.onrender.com/api/feedback/get-feedbacks/0");
      const data = await response.json();
      if (response.ok) setCustomerFeedbacks(data);
      else alert('Failed to fetch feedbacks');
    } catch {
      alert('Failed to fetch feedbacks');
    } finally {
      setLoading(false);
    }
  };

  const markResolved = async (id) => {
    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/contact/mark-resolved/${id}`, { method: 'PUT' });
      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        getUserQueries();
      } else {
        alert(data.error || 'Error marking as resolved');
      }
    } catch {
      alert('Failed to mark as resolved');
    }
  };

  const deleteQuery = async (id) => {
    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/contact/delete-contact-message/${id}`, { method: 'DELETE' });
      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        getUserQueries();
      } else {
        alert(data.error || 'Error deleting query');
      }
    } catch {
      alert('Failed to delete query');
    }
  };

  const updatePaymentStatus = async (orderId, status) => {
    const response = await fetch("https://swarna-herbal-backend.onrender.com/api/orders/update-payment-status", {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderId, paymentStatus: status }),
    });

    const data = await response.json();
    if (response.ok) {
      alert('Payment status updated');
      getOrders();
    } else {
      alert(data.message || 'Error updating payment status');
    }
  };

  const updateDeliveryStatus = async (orderId, status) => {
    const response = await fetch("https://swarna-herbal-backend.onrender.com/api/orders/update-delivery-status", {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderId, deliveryStatus: status }),
    });

    const data = await response.json();
    if (response.ok) {
      alert('Delivery status updated');
      getOrders();
    } else {
      alert(data.message || 'Error updating delivery status');
    }
  };

  const markFeedbackResolved = async (id) => {
    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/feedback/mark-resolved/${id}`, {
        method: 'PUT',
      });
      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        getCustomerFeedbacks();
      } else {
        alert(data.error || 'Error updating feedback status');
      }
    } catch {
      alert('Failed to update feedback status');
    }
  };

  const deleteFBQuery = async (id) => {
    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/feedback/delete-feedback/${id}`, {
        method: 'DELETE',
      });
      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        getCustomerFeedbacks();
      } else {
        alert(data.error || 'Error deleting feedback status');
      }
    } catch {
      alert('Failed to delete feedback status');
    }
  };

  const updateEstimatedDeliveryDate = async (orderId) => {
    const newDate = estimatedDates[orderId];
    if (!newDate) return alert("Please select a valid date");

    try {
      const response = await fetch(`https://swarna-herbal-backend.onrender.com/api/orders/update-estimated-delivery-date/${orderId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estimatedDeliveryDate: newDate }),
      });

      const data = await response.json();
      if (response.ok) {
        alert('Estimated Delivery Date updated');
        getOrders();
      } else {
        alert(data.message || 'Failed to update date');
      }
    } catch {
      alert('Error while updating estimated delivery date');
    }
  };

  const formatDate = (dateStr) => {
    return dateStr ? new Date(dateStr).toISOString().split('T')[0] : '';
  };

  const filteredOrders = orders.filter((order) =>
    order.phone.includes(searchQuery)
  );

  const getProducts = async () => {
    try {
      const res = await fetch('https://swarna-herbal-backend.onrender.com/api/products');
      const data = await res.json();
      if (res.ok) setProducts(data.products);
      else alert('Failed to fetch products');
    } catch {
      alert('Error fetching products');
    }
  };


  const deleteProduct = async (id) => {
    try {
      const res = await fetch(`https://swarna-herbal-backend.onrender.com/api/products/${id}`, { method: 'DELETE' });
      const data = await res.json();
      if (res.ok) {
        alert('Product deleted');
        getProducts();
      } else {
        alert(data.error || 'Failed to delete');
      }
    } catch {
      alert('Error deleting product');
    }
  };



  useEffect(() => {
    if (isLoggedIn) {
      getOrders();
      getUserQueries();
      getCustomerFeedbacks();
      getProducts(); // fetch products as well
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (view === 'products') getProducts();
  }, [view]);

  return (
    <div className="admin-container">
      <h2>Admin</h2>

      {!isLoggedIn ? (
        <div className="login-form">
          <h3>Login</h3>
          <form onSubmit={handleLogin}>
            <input type="text" name="username" placeholder="Username" value={loginData.username} onChange={handleLoginChange} required />
            <input type="password" name="password" placeholder="Password" value={loginData.password} onChange={handleLoginChange} required />
            <button type="submit">Login</button>
          </form>
          {error && <p className="error">{error}</p>}
        </div>
      ) : (
        <>
          <div className="buttons">
            <button onClick={() => setView('orders')} className={view === 'orders' ? 'active' : ''}>Orders</button>
            <button onClick={() => setView('userQueries')} className={view === 'userQueries' ? 'active' : ''}>User Queries</button>
            <button onClick={() => setView('customerFeedback')} className={view === 'customerFeedback' ? 'active' : ''}>Customer Feedback</button>
            <button onClick={() => setView('products')} className={view === 'products' ? 'active' : ''}>AddProduct</button>

          </div>

          {view === 'orders' && (
            <input
              type="text"
              placeholder="Search by phone number"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          )}

          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="data-table">
              {view === 'orders' && (
                <div className="orders-list">
                  <h3>Orders List</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Customer Name</th>
                        <th>Items Ordered</th>
                        <th>Price (₹)</th>
                        <th>Total Quantity</th>
                        <th>Phone</th>
                        <th>Order Date</th>
                        <th>Estimated Delivery</th>
                        <th>Update</th>
                        <th>Delivery Address</th>
                        <th>Payment Status</th>
                        <th>Delivery Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredOrders.length === 0 ? (
                        <tr><td colSpan="12">No orders found</td></tr>
                      ) : (
                        filteredOrders.map((order) => (
                          <tr key={order._id}>
                            <td>{order._id}</td>
                            <td>{order.userName}</td>
                            <td>{order.itemName}</td>
                            <td>{order.price}</td>
                            <td>{order.quantity}</td>
                            <td>{order.phone}</td>
                            <td>{formatDate(order.createdAt)}</td>
                            <td>
                              <input
                                type="date"
                                value={estimatedDates[order._id] || formatDate(order.estimatedDeliveryDate)}
                                onChange={(e) =>
                                  setEstimatedDates((prev) => ({
                                    ...prev,
                                    [order._id]: e.target.value,
                                  }))
                                }
                              />
                            </td>
                            <td>
                              <FontAwesomeIcon
                                icon={faSave}
                                style={{ color: 'blue', cursor: 'pointer' }}
                                onClick={() => updateEstimatedDeliveryDate(order._id)}
                              />
                            </td>
                            <td>Landmark: {order.landmark}, City: {order.city}, State: {order.state}, PinCode: {order.pinCode}</td>
                            <td>
                              <select value={order.paymentStatus} onChange={(e) => updatePaymentStatus(order._id, e.target.value)}>
                                <option value="Pending">Pending</option>
                                <option value="Completed">Completed</option>
                                <option value="Failed">Failed</option>
                              </select>
                            </td>
                            <td>
                              <select value={order.deliveryStatus} onChange={(e) => updateDeliveryStatus(order._id, e.target.value)}>
                                <option value="Pending">Pending</option>
                                <option value="Confirmed">Confirmed</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Delivered">Delivered</option>
                              </select>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {view === 'userQueries' && (
                <div className="user-queries-list">
                  <h3>User Queries</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userQueries.map((query) => (
                        <tr key={query._id}>
                          <td>{query.name}</td>
                          <td>{query.phone}</td>
                          <td>{query.message}</td>
                          <td>{query.status}</td>
                          <td>
                            {query.status === 'Pending' ? (
                              <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green', cursor: 'pointer' }} onClick={() => markResolved(query._id)} />
                            ) : <span>Resolved</span>}
                            <FontAwesomeIcon icon={faTrashAlt} style={{ color: 'red', cursor: 'pointer', marginLeft: '10px' }} onClick={() => deleteQuery(query._id)} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {view === 'customerFeedback' && (
                <div className="user-queries-list">
                  <h3>Customer Feedback</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Message</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerFeedbacks.map((fb) => (
                        <tr key={fb._id}>
                          <td>{fb.name}</td>
                          <td>{fb.phone}</td>
                          <td>{fb.feedback}</td>
                          <td>{fb.status}</td>
                          <td>
                            {fb.status === 'Pending' ? (
                              <FontAwesomeIcon icon={faCheckCircle} style={{ color: 'green', cursor: 'pointer' }} onClick={() => markFeedbackResolved(fb._id)} />
                            ) : <span>Confirmed</span>}
                            <FontAwesomeIcon icon={faTrashAlt} style={{ color: 'red', cursor: 'pointer', marginLeft: '10px' }} onClick={() => deleteFBQuery(fb._id)} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {view === 'products' && (
                <div className="products-section">
                  <button onClick={toggleAddForm} className="add-product-btn">
                    {showAddForm ? 'Back to Product List' : 'Add New Product'}
                  </button>

                  {showAddForm ? (
                    // Show form component - pass props to manage form state & update
                    <AddProduct
                      editdata={Object.keys(editData).length > 0 ? editData : null}
                      onCancel={() => {
                        setShowAddForm(false);
                        setEditData({});
                        getProducts()
                      }}

                    />
                  ) : (
                    // Show product list table
                    <table className="products-table" style={{ width: "100vw" }}>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Category</th>
                          <th>Type</th>
                          <th>Body Type</th>
                          <th>Price (₹)</th>
                          <th>Offer Price (₹)</th>
                          <th>% Discount</th>
                          <th>Description</th>
                          <th>Image URL</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.length === 0 ? (
                          <tr>
                            <td colSpan="5">No products found.</td>
                          </tr>
                        ) : (
                          products.map((product) => (
                            <tr key={product._id}>
                              <td>{product.name}</td>
                              <td>{product.category}</td>
                              <td>{product.type}</td>
                              <td>{product.bodyTypes}</td>
                              <td>{product.price}</td>
                              <td>{product.offerPrice}</td>
                              <td>{product.discountPercent}</td>
                              <td>{product.description}</td>
                              <td>
                                {product.image ? (
                                  <img
                                    src={`https://swarna-herbal-backend.onrender.com/uploads/${product.image}`}
                                    alt={product.name}
                                    style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '6px' }}
                                  />
                                ) : (
                                  'No image'
                                )}
                              </td>
                              <td>
                                <label title="Mark as New Launch">
                                  <input
                                    type="checkbox"
                                    checked={product.newLaunch}
                                    onChange={(e) => handleNewLaunchChange(product._id, e.target.checked)}
                                  />
                                  🚀 New Launch
                                </label>

                                <label title="Mark as Popular" style={{ marginLeft: "10px" }}>
                                  <input
                                    type="checkbox"
                                    checked={product.popular}
                                    onChange={(e) => handlePopularChange(product._id, e.target.checked)}
                                  />
                                  ⭐ Popular
                                </label>


                                <button
                                  onClick={() => { setEditData(product); setShowAddForm(true) }}
                                  className="btn edit-btn"
                                  title="Edit"
                                >
                                  <FontAwesomeIcon icon={faEdit} />
                                </button>
                                <button
                                  onClick={() => deleteProduct(product._id)}
                                  className="btn delete-btn"
                                  title="Delete"
                                >
                                  <FontAwesomeIcon icon={faTrashAlt} />
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Admin;
